export enum ErrorCode {
    UnknownError = 1001,
    ParamsError = 1003,

    UserNotLogin = 2000,
    UserNotExist = 2001,
    UserNoPermission = 2002,
    // 资金时段范围查询被拒;用 6 位自定义码避开 4 位 Java 业务码段,前端映射为专用文案而非通用「用户无权限」。
    TimeRangeNoPermission = 230002,

    UserLoginError = 2003,
    UserDisabled = 2008,
    UserDeleted = 2013,

    LoginStatusChange = 2800,

    // Map Finpass OTP API error code to BSS error code for the MTS wording
    FINPASS_OTP_INCORRECT = 2025,
    FINPASS_MFA_NOT_BIND = 2026,
    FINPASS_TOKEN_EXPIRED = 2027,
    MfaRequired = 2028,
    OtpInvalid = 5100,
}
